var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.$vuetify.theme.dark ? 'background: #141414;' : 'background: #ECEFF1;'),attrs:{"id":"sandbox","dark":_vm.dark}},[_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }